import { Reducer } from "redux";
import {
    LocaleActions,
    LocaleState,
    ChangeLanguageAction,
    ToggleLanguageSelectionVisibilityAction,
    LoadLanguageServiceFromServerAction
} from "./type";
import {
    changeApplicationLanguage,
    ToggleLanguageSelectionVisibilityHandler,
    loadLanguageServiceFromServerHandler
} from "./handlers";
import {
    CHANGE_LANGUAGE,
    TOGGLE_LANGUAGE_SELECTION_VISIBILITY,
    LOAD_LANGUAGE_SERVICE_FROM_SERVER
} from "./constants";
import { LanguageCodes } from "../../constants/languages";

export const initialState: LocaleState = {
    lang: LanguageCodes.French,
    textLibrary: null,
    currentLanguageText: null,
    showLanguageSelection: false
};

const reducer: Reducer<LocaleState> = (state: LocaleState = initialState, action: LocaleActions) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return changeApplicationLanguage(state, action as ChangeLanguageAction);

        case TOGGLE_LANGUAGE_SELECTION_VISIBILITY:
            return ToggleLanguageSelectionVisibilityHandler(state, action as ToggleLanguageSelectionVisibilityAction);

        case LOAD_LANGUAGE_SERVICE_FROM_SERVER:
            return loadLanguageServiceFromServerHandler(state, action as LoadLanguageServiceFromServerAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/LanguageLocale/reducer.ts